import * as themeConfig from 'vessel/theme/config/tailwind.js'
import * as localConfig from '~/vessel.config.js'

const custom = localConfig.default || localConfig || {}
const cfgFun = themeConfig.default || themeConfig
const config = cfgFun(custom)

function aliases() {
  const options  = custom.theme || {}
  const typo     = options.typography || {}
  const border   = options.border || {}
  const sections = ['body', 'title', 'paragraph', 'link']
  const defaults = { font: 'roboto', leading: 'md', color: 'black', weight: 'normal', size: 'md' }
  const mappings = { font: {}, lineHeight: {}, textColor: {}, fontWeight: {}, textSize: {}, borderColor: {} }

  sections.forEach(name => {
    const item = { ...typo[name] }
    const data = { ...defaults, ...typo.body, ...item }

    if (name == 'link' && !item.color) {
      data.color = 'primary'
    }

    mappings.font[name]       = data.font
    mappings.lineHeight[name] = data.leading
    mappings.textColor[name]  = data.color
    mappings.fontWeight[name] = data.weight
    mappings.textSize[name]   = data.size
  })

  mappings.borderColor.default = border.color || 'grey-light'

  return mappings
}

export default {
  aliases: aliases(),
  ...config
}
